import type { JSX } from "react";
import { cn } from "./cn";
import { Stack } from "./Stack";
import { Text } from "./Text";
import { Card } from "./Card";

export interface NoteCardProps {
  /** Note body text */
  readonly content: string;
  /** Metadata line below the note */
  readonly meta: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A bordered note card with content and metadata.
 */
export function NoteCard({ content, meta, className }: NoteCardProps): JSX.Element {
  return (
    <Stack className={cn("mb-2", className)}>
      <Card className="p-3">
        <Text variant="body">{content}</Text>
      </Card>
      <Text variant="tiny" color="tertiary" className="mt-1">{meta}</Text>
    </Stack>
  );
}
